// Общее для карточек клиента и группы: строка о клиенте в списке, последний переезд, правила отмены, коды календаря.
import { RU_DAYS, money, plural, ruDateShort, ruleLabel, type ClientOut } from '@praktika/core';
import { meetShort, typeById, typeName } from '../lib/data.ts';
import { chooseSheet, promptSheet } from '../lib/sheet.ts';

// «Стандартная 50 · 15 000 AMD · пн 10:00 · Meet»
export function clientInfo(c: ClientOut): string {
  const tid = c.effTypeId || c.typeId;
  return [tid ? typeName(tid) + ' ' + (typeById(tid).dur || '') : '', c.effPrice ? money(c.effPrice, c.effCur) : '',
    c.slotDay !== null ? RU_DAYS[c.slotDay]!.toLowerCase() + ' ' + c.slotTime : 'без слота', meetShort(c)]
    .filter(Boolean).join(' · ');
}

// Последний переезд клиента: «из «Личные» с 24.09.2026».
export function lastMove(c: ClientOut): string {
  const m = c.moves[c.moves.length - 1];
  return m ? 'из «' + m.fromName + '» с ' + ruDateShort(m.date) : '';
}

export function cntClients(n: number): string { return n + ' ' + plural(n, 'клиент', 'клиента', 'клиентов'); }

export function ruleText(v: string | null | undefined, cur: string | null | undefined): string {
  return v === '' || v === undefined || v === null ? '' : ruleLabel(v, cur);
}

export function chooseRule(label: string, current: string | null, cur: string | null, cb: (v: string) => void): void {
  chooseSheet(label, [{ value: '0%', label: 'Без оплаты', hint: '0%' }, { value: '50%', label: 'Половина цены',
    hint: '50%' }, { value: '100%', label: 'Полная цена', hint: '100%' }, { value: '__sum', label: 'Своя сумма…' }],
  current ?? '', (v) => {
    if (v === '__sum') {
      promptSheet('Сумма, ' + (cur ?? ''), /%$/.test(String(current ?? '')) ? '' : current, 'number', (x) => {
        if (x !== '') cb(String(Number(x)));
      });
    } else cb(v);
  });
}

export const MESSENGERS = [{ value: 'WhatsApp', label: 'WhatsApp' }, { value: 'Telegram', label: 'Telegram' },
  { value: '—', label: 'Нет' }];

// Коды календаря группы: короткие первыми, «хПК» (бывшие) — после основных.
export function sortCodes(codes: readonly string[]): string[] {
  return codes.slice().sort((a, b) => (/^[хx]/.test(a) ? 1 : 0) - (/^[хx]/.test(b) ? 1 : 0) || a.length - b.length);
}
